// import { useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { Link } from "react-router-dom";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import Logo from "../../../../assets/logo-tokorame.svg";

import {
  IconButton,
  AppBar,
  Toolbar,
  Typography,
} from "@material-ui/core";
// import { auth } from '../../../firebase/FirebaseProvider';

const useStyles = makeStyles(theme => ({
  title: {
    flexGrow: 1,
    color: 'black',
    marginLeft: '-3%',
    marginBottom: '-8px',
    fontWeight: 'normal'

  },
  link: {
    color: '#537ED4',
    textDecoration: 'none',
    '&:hover': {
      color: '#3333B0'
    }
  },
  menuButton: {
    // marginRight: theme.spacing(2),
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
}));

export default function Header(nameStatus) {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('tablet'));


  // const logout = () => {
  //   auth.signOut();
  // };
  return (
    <div className={classes.header}>
      <AppBar
        position="static"
        style={{
          backgroundColor: "#fff",
          boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
        }}
      >
        <Toolbar
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginLeft: "5%",
            marginRight: "10%",
            paddingLeft: "0",
            paddingRight: "0",
          }}
        >
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
          // onClick={logout}
          >
            <img
              src={Logo}
              alt="Logo"
              style={{ width: "70%", height: "100%" }}
            />
          </IconButton>
          {matches ?
            <Typography variant="h6" className={classes.title}>
              {nameStatus.nameStatus}
            </Typography>
            : null}

          {matches ?
            <Link onClick={() => window.open(`https://play.google.com/store/apps/details?id=com.tokorame.resellerapp`)} className={classes.link}>
              Download Aplikasi Tokorame
            </Link>
            : null}
        </Toolbar>
      </AppBar>
    </div>
  );
}